"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = unsupportedProp;

function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/utils/unsupportedProp.js
// module id = 326
// module chunks = 0